<kendo-dialog (close)="cancelCaseBillable()" [minWidth]="400" [width]="1400">
    <kendo-dialog-titlebar>
        <h3 class="ellipsis-text">{{ 'ADD-BILLABLE' | translate }}</h3>
    </kendo-dialog-titlebar>

    <form [formGroup]="caseBillableForm" class="k-form" (ngSubmit)="saveCaseBillable()">
        <div class="row">
            <div class="col-4">
                <label for="feeSchedule" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">{{ 'FEE-SCHEDULE' | translate }} *</span>
                    <kendo-combobox class="w-100" formControlName="feeSchedule" [data]="feeSchedules"
                        [textField]="'displayName'" [valueField]="'id'" [valuePrimitive]="false">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="feeSchedule.hasError('required') && feeSchedule.touched">
                        {{ 'REQUIRED-FEE-SCHEDULE' | translate }}
                    </div>
                </label>
            </div>
            <!-- Fee Category -->
            <div class="col-4">
                <label for="feeCategory" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">{{ 'FEE-CATEGORY' | translate }} *</span>
                    <kendo-combobox class="w-100" formControlName="feeCategory" [data]="feeCategories"
                        [textField]="'displayName'" [valueField]="'id'" [valuePrimitive]="false">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="feeCategory.hasError('required') && feeCategory.touched">
                        {{ 'REQUIRED-FEE-CATEGORY' | translate }}
                    </div>
                </label>
            </div>
            <!-- Billable Service -->
            <div class="col-4">
                <label for="billableServiceControl" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">{{ 'BILLABLE-SERVICE' | translate }} *</span>
                    <kendo-combobox id="billableServiceControl" formControlName="billableServiceControl"
                        [data]="billableServicesFiltered" [valueField]="'id'" [textField]="'name'" [filterable]="true"
                        (filterChange)="filterBillableServices($event)">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="billableServiceControl.hasError('required') && billableServiceControl.touched">
                        {{ 'REQUIRED-BILLABLE-SERVICE' | translate }}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <!-- Date of Service -->
            <div class="col-4">
                <label for="dateOfService" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">{{ 'DATE-OF-SERVICE' | translate }} *</span>
                    <kendo-datepicker formControlName="dateOfService" [max]="maxDateOfService">
                    </kendo-datepicker>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="dateOfService.hasError('required') && dateOfService.touched">
                        {{ 'REQUIRED-DATE-OF-SERVICE' | translate }}
                    </div>
                </label>
            </div>
            <!-- Units -->
            <div class="col-4">
                <label for="units" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">{{ 'UNITS' | translate }} *</span>
                    <kendo-numerictextbox [format]="'n0'" [decimals]="0" formControlName="units" [min]="1">
                    </kendo-numerictextbox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="units.hasError('required') && units.touched">
                        {{ 'REQUIRED-UNITS' | translate }}
                    </div>
                </label>
            </div>
            <div class="col-4">
                <div *ngIf="billableServiceHasManualAmount !== null && billableServiceHasManualAmount">
                    <label for="totalAmount" class="k-form-field w-100">
                        <span class="k-text-uppercase dark">{{ 'TOTAL-AMOUNT' | translate }} *</span>
                        <kendo-numerictextbox [format]="'n2'" formControlName="totalAmount">
                        </kendo-numerictextbox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="totalAmount.hasError('required') && totalAmount.touched">
                            {{ 'REQUIRED-TOTAL-AMOUNT' | translate }}
                        </div>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- Diagnoses -->
            <div class="col-4">
                <label for="diagnoses" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">{{ 'DIAGNOSES' | translate }} *</span>
                    <input kendoTextBox formControlName="diagnoses" class="w-100" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="diagnoses.hasError('required') && diagnoses.touched">
                        {{ 'REQUIRED-DIAGNOSES' | translate }}
                    </div>
                </label>
            </div>
            <div class="col-4">
                <label for="organization" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">{{ 'ORGANIZATION' | translate }} *</span>
                    <kendo-combobox id="organization" formControlName="organization" class="w-100"
                        [valuePrimitive]="false" [itemDisabled]="itemDisabled" [data]="organizations"
                        [textField]="'name'" [valueField]="'id'">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="organization.hasError('required') && organization.touched">
                        {{'REQUIRED-ORGANIZATION' | translate}}
                    </div>
                </label>
            </div>
        </div>
    </form>
    <div>* {{ 'REQUIRED-FIELDS' | translate }}</div>

    <kendo-dialog-actions>
        <button kendoButton (click)="cancelCaseBillable()">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick kendoButton (click)="saveCaseBillable()" [primary]="true"
            [disabled]="!caseBillableForm.valid || !caseBillableForm.dirty">
            {{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>